var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { FInter, MagicBox } from '@brg/ui';
import earth from '../../../images/inputs/earth.svg';
import useLocalization from '../../../hooks/useLocalization';
import styled from 'styled-components';
var EarthSVG = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"], ["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"])), earth);
export var ProjectSearchBartDisplay = function (props) {
    // @ts-ignore
    var t = useLocalization().t;
    return (React.createElement(MagicBox, { align: 'center', color: '#8e9193', hoverColor: '#151514', gx: 8, onClick: props.onDisplayChange, pointer: true, offsetRight: props.hideRightBar ? 0 : 20 },
        React.createElement(FInter.SmallTextDiv, null,
            React.createElement("div", null, t('exploreView.toggle.' + props.display))),
        React.createElement(EarthSVG, null)));
};
var templateObject_1;
//# sourceMappingURL=projectSearchBartDisplay.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { FInter, MagicBox } from '@brg/ui';
import earth from '../../../images/inputs/earth.svg';
import useLocalization from '../../../hooks/useLocalization';
import styled from 'styled-components';
var EarthSVG = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"], ["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"])), earth);
export var ProjectSearchBartDisplay = function (props) {
    // @ts-ignore
    var t = useLocalization().t;
    return (React.createElement(MagicBox, { align: 'center', color: '#8e9193', hoverColor: '#151514', gx: 8, onClick: props.onDisplayChange, pointer: true, offsetRight: props.hideRightBar ? 0 : 20 },
        React.createElement(FInter.SmallTextDiv, null,
            React.createElement("div", null, t('exploreView.toggle.' + props.display))),
        React.createElement(EarthSVG, null)));
};
var templateObject_1;
//# sourceMappingURL=projectSearchBartDisplay.js.map